import React from 'react';

function Footer(props) {
    return (
        <div></div>
    );
}

export default Footer;